
if (document.querySelector('.gp-landing') && !window.gpLandingPopupsReady) {
  window.gpLandingPopupsReady = true;
  const dismissed = new WeakSet();
  let scheduled = false;
  const dismissLandingPopups = () => {
    scheduled = false;
    document.querySelectorAll('[data-kl-scroll-locking-modal="true"]').forEach((modal) => {
      const closeButton = modal.querySelector('button[aria-label="Close dialog"]');
      if (closeButton && !dismissed.has(modal)) {
        dismissed.add(modal);
        closeButton.click();
      }
    });
  };
  new MutationObserver(() => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(dismissLandingPopups);
    }
  }).observe(document.body, { childList: true, subtree: true });
  dismissLandingPopups();
}
